/**
 * Tool Category Badge Component
 * Displays a category chip with consistent styling
 */

import { Badge } from '@/components/ui/badge';
import { type ToolboxCategory, TOOLBOX_CATEGORY_LABELS } from '@/types/toolbox';
import { cn } from '@/lib/utils';

interface ToolCategoryBadgeProps {
  category: ToolboxCategory;
  className?: string;
}

const CATEGORY_COLORS: Record<ToolboxCategory, string> = {
  scan_tool: 'bg-blue-500/10 text-blue-600 border-blue-500/20',
  electrical_diagnostics: 'bg-yellow-500/10 text-yellow-600 border-yellow-500/20',
  adas: 'bg-purple-500/10 text-purple-600 border-purple-500/20',
  driveability: 'bg-green-500/10 text-green-600 border-green-500/20',
  diesel: 'bg-orange-500/10 text-orange-600 border-orange-500/20',
  hvac: 'bg-cyan-500/10 text-cyan-600 border-cyan-500/20',
  programming: 'bg-indigo-500/10 text-indigo-600 border-indigo-500/20',
  specialty: 'bg-pink-500/10 text-pink-600 border-pink-500/20',
  hand_tools: 'bg-slate-500/10 text-slate-600 border-slate-500/20',
  tech_equipment: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/20',
  other: 'bg-muted text-muted-foreground border-border',
};

export function ToolCategoryBadge({ category, className }: ToolCategoryBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'text-xs font-medium border',
        CATEGORY_COLORS[category],
        className
      )}
    >
      {TOOLBOX_CATEGORY_LABELS[category]}
    </Badge>
  );
}
